import { render, staticRenderFns } from "./PorletComentarios.vue?vue&type=template&id=6fc60e95"
import script from "./PorletComentarios.vue?vue&type=script&lang=js"
export * from "./PorletComentarios.vue?vue&type=script&lang=js"
import style0 from "./PorletComentarios.vue?vue&type=style&index=0&id=6fc60e95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports